if (!customElements.get('carnakit-pairing-progress')) {
  customElements.define(
    'carnakit-pairing-progress',
    class CarnakitPairingProgress extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold) || 0;
        this.currentTotal = Number(this.dataset.cartTotal) || 0;
        this.currency = this.dataset.currency || 'EUR';
        this.locale = this.dataset.locale || 'fr-FR';
        this.totalElement = this.querySelector('[data-pairing-cart-total]');
        this.remainingElement = this.querySelector('[data-pairing-remaining]');
        this.remainingState = this.querySelector('[data-pairing-remaining-state]');
        this.unlockedState = this.querySelector('[data-pairing-unlocked-state]');
        this.progressTrack = this.querySelector('[data-pairing-progress-track]');
        this.animationFrame = null;
        this.requestNumber = 0;

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
        }

        this.renderTotal(this.currentTotal, false);
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      }

      async refreshCart() {
        const requestNumber = ++this.requestNumber;

        try {
          const response = await fetch(`${window.routes.cart_url}.js`, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
          });
          if (!response.ok) return;

          const cart = await response.json();
          if (requestNumber !== this.requestNumber) return;
          this.renderTotal(Number(cart.total_price) || 0, true);
        } catch (error) {
          console.error(error);
        }
      }

      renderTotal(nextTotal, animate) {
        const startTotal = this.currentTotal;
        this.currentTotal = nextTotal;
        const progress = this.threshold > 0 ? Math.min((nextTotal / this.threshold) * 100, 100) : 100;
        const isUnlocked = nextTotal >= this.threshold;

        requestAnimationFrame(() => {
          this.style.setProperty('--ck-pairing-progress', `${progress}%`);
          this.classList.toggle('is-unlocked', isUnlocked);
          if (this.remainingState) this.remainingState.hidden = isUnlocked;
          if (this.unlockedState) this.unlockedState.hidden = !isUnlocked;
          if (this.progressTrack) {
            this.progressTrack.setAttribute('aria-valuenow', Math.min(nextTotal, this.threshold));
            this.progressTrack.setAttribute(
              'aria-valuetext',
              `${this.formatMoney(nextTotal)} sur ${this.formatMoney(this.threshold)}`
            );
          }
        });

        if (!animate || startTotal === nextTotal || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.updateAmounts(nextTotal);
          return;
        }

        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        const duration = 700;
        const startedAt = performance.now();

        const step = (now) => {
          const elapsed = Math.min((now - startedAt) / duration, 1);
          const eased = elapsed < 0.5 ? 2 * elapsed * elapsed : 1 - Math.pow(-2 * elapsed + 2, 2) / 2;
          this.updateAmounts(Math.round(startTotal + (nextTotal - startTotal) * eased));

          if (elapsed < 1) {
            this.animationFrame = requestAnimationFrame(step);
          } else {
            this.animationFrame = null;
          }
        };

        this.animationFrame = requestAnimationFrame(step);
      }

      updateAmounts(total) {
        if (this.totalElement) this.totalElement.textContent = this.formatMoney(total);
        if (this.remainingElement) {
          this.remainingElement.textContent = this.formatMoney(Math.max(this.threshold - total, 0));
        }
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
        }).format((Number(cents) || 0) / 100);
      }
    }
  );
}
